
import { addSatInfoCZMLLayer, removeSatInfoCZMLLayer } from './addSatInfoLayer'

function addSatOrbGeoLayer (layerInfo, viewer) {
  // 设置 entity存储
  const data = layerInfo.data
  const data1 = geojsondata2json(data)
  layerInfo.data = data1
  // 调用 czml 添加
  addSatInfoCZMLLayer(layerInfo, viewer)
}

function removeSatOrbGeoLayer (layerInfo, viewer) {
  removeSatInfoCZMLLayer(layerInfo, viewer)
}

const defaultStyle = {
  lineStlye: {
    lineColor: [0, 255, 255, 255],
    outlineColor: [0, 255, 255, 255],
    outlineWidth: 2,
    lineWidth: 2
  },
  lineStlye1: { lineColor: [0, 255, 255, 255], outlineColor: [0, 255, 255, 255], outlineWidth: 2, lineWidth: 2 },
  pointStlye: {
    labelFillColor: [255, 255, 255, 255],
    labelBackgroundColor: [0, 0, 0, 0],
    pointColor: [0, 255, 255, 255],
    pixelSize: 20,
    outlineColor: [0, 255, 255, 255],
    outlineWidth: 2
  }
}
/**
 * 数据转化 geojson数据 -> json 格式 数据
 * @param {geojson} data geojson格式 轨道数据
 */
function geojsondata2json (data) {
  const data1 = {}
  const featuresList = data.features

  const lineList = []
  const pointList = []
  featuresList.forEach(feature => {
    if (getLine(feature)) {
      //  lineList.push(feature)
      const lineInfo = getLineStyle(feature)
      lineList.push(lineInfo)
    } else {
      const pointInfo = getPointStyle(feature)
      pointList.push(pointInfo)
    }
  })
  data1.data = {
    lineList: lineList,
    pointList: pointList
  }
  // TODO 修改样式配置获取
  data1.style = defaultStyle
  return data1
}

function getPointStyle (feature) {
  const geometry = feature.geometry
  const coordinates = geometry.coordinates
  const properties = feature.properties
  const time = properties.title
  const pointInfo = coordinates
  const demo = {
    style: 'pointStlye',
    height: 840000,
    position: pointInfo,
    title: time
  }
  return demo
}

function getLine (feature) {
  const geometry = feature.geometry
  const type = geometry.type
  if (type === 'LineString') {
    return true
  }
  return false
}

function getLineStyle (feature) {
  const geometry = feature.geometry
  const coordinates = geometry.coordinates
  const pointList = coordinates

  const demo = {
    satNum: 2399,
    style: 'lineStlye1',
    startTime: '2021-12-21 00:00:00',
    height: 840000,
    position: pointList,
    endTime: '2021-12-21 00:58:00'
  }
  return demo
}

export { addSatOrbGeoLayer, removeSatOrbGeoLayer }
